import { PetType } from 'constants/pet-type';
import { DogProfile } from 'types/pet-profile';

export enum PetProfileIllustrationType {
  Breed = 'breed',
  DogFilled = 'dog-filled',
  DogEmpty = 'dog-empty',
  CatFilled = 'cat-filled',
  CatEmpty = 'cat-empty',
}

interface GetPetProfileIllustrationType {
  breed: DogProfile['selectedBreed'];
  petType: PetType;
  isEmpty: boolean;
}

export const getPetProfileIllustrationType = ({
  breed,
  petType,
  isEmpty,
}: GetPetProfileIllustrationType): PetProfileIllustrationType => {
  if (breed) {
    return PetProfileIllustrationType.Breed;
  }

  if (petType === PetType.Dog) {
    return isEmpty ? PetProfileIllustrationType.DogEmpty : PetProfileIllustrationType.DogFilled;
  }

  return isEmpty ? PetProfileIllustrationType.CatEmpty : PetProfileIllustrationType.CatFilled;
};
